module.exports = __webpack_public_path__ + "static/img/img_map_06.ea59ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_map_06.png
// module id = 0Ms/
// module chunks = 19